export default __webpack_public_path__ + "static/media/sanlucas4_g.7d9bc3e1.jpg";